var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EB00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44105 8.24725C9.1114 7.91759 8.57692 7.91758 8.24725 8.24723C7.91759 8.57687 7.91758 9.11134 8.24724 9.441L14.8062 16L8.24724 22.559C7.91758 22.8887 7.91759 23.4231 8.24725 23.7528C8.57692 24.0824 9.1114 24.0824 9.44105 23.7528L16 17.1938L22.5589 23.7528C22.8886 24.0824 23.4231 24.0824 23.7527 23.7528C24.0824 23.4231 24.0824 22.8887 23.7528 22.559L17.1938 16L23.7528 9.441C24.0824 9.11134 24.0824 8.57687 23.7527 8.24723C23.4231 7.91758 22.8886 7.91759 22.5589 8.24725L16 14.8062L9.44105 8.24725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3308134457254fb272e97a3bd5d7e529.svg";
export { ForwardRef as ReactComponent };